





import Vue from 'vue';
import SignUp from '@/views/signUp/SignUp.vue';

export default Vue.extend({
  components: {
    SignUp,
  },
  data: () => ({
    renderComponent: true,
  }),

  methods: {
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
  },
});
